// import logo from './logo.svg';
import './App.css';
import Weather from './Components/Wheather';

function App() {
  return (
    <div className="App">
      <Weather/>
    </div>
  );
}

export default App;
